import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import QRCode from 'qrcode.react';
import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';
import store from 'store';
import Cookies from 'js-cookie';
import { VERSION, setIsHomeFirstScreen, setFirst } from './utils'
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import { storeHistory } from '../actions/playlistActions';

export class InfoPage extends React.Component {

  constructor() {
    super();
    this.STORE_KEYS = {
      user: 'auth__user',
      token: 'auth__token',
    };
    this.state = {
      user: ''
    }
  }

  componentDidMount() {
    this.props.setHistory(this.props.history);
    var back = this.refs.back;
    back.focus();

    const user = store.get(this.STORE_KEYS.user);
    this.setState({
      user
    })
  }

  logout() {
    const topDomain = (function topDomain() {
      const match = location.hostname.match(/(\.\w+.\.\w+$|192.168.0.11)/);
      if (!match) {
        return null;
      }
      return match[0];
    }());

    const userId = this.state.user.id;
    const deviceId = store.get('device-id');

    bdReq.delete(`/users/${userId}/devices/${deviceId}`)
      .then((data) => {
        if (data.success) {
          store.remove('device-id');
        }
      }).catch(() => { });

    store.remove('subscription');
    store.remove('description');
    store.remove('device-id');
    store.remove('device-name');
    store.remove('art-id');
    store.remove('featured');
    store.remove(this.STORE_KEYS.user);
    Cookies.remove(this.STORE_KEYS.token, { domain: topDomain });
    setIsHomeFirstScreen(false);
    setFirst(1);
    this.props.history.push('/freemium');
  }

  getAccount() {
    return this.state.user.email;
  }

  getDescription() {
    const desc = store.get('description');
    return desc;
  }

  getDeviceId() {
    return store.get('bd-android-app__device-id');
  }

  render() {
    return (
      <section className="info">
        <video className="info__video" src="https://assets.blackdove.com/videos/boris_marinin_elan_vital.mp4" autoPlay loop poster="data:image/gif,AAAA"></video>
        <div className="info__wrapper">
          <div className="info__wrapper__container">
            <img className="info__wrapper__container__logo" src="https://assets.blackdove.com/images/bd_logo_horizontal_alternate.svg" />
            <div className="row row--push-btm-xs">
              <h6 className="info__wrapper__container h--normalize-weight h--lower info__h6">
                Go to https://account.blackdove.com to change<br />your account details and edit your subscription.
                </h6>
            </div>
            <div className="row row--push-btm-xs">
              <div className="col-12">
                <hr style={{ borderBottom: "1px solid #e1e6eae8", borderColor: "#9da7af4a" }} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <h6 style={{ float: "left" }} className="info__h6 h--spacing-sm" >
                  Account:
                </h6>
              </div>
            </div>
            <div className="row row--push-btm-xs">
              <div className="col-12">
                <h6 style={{ float: "left" }}>
                  {this.getAccount()}
                </h6>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <h6 style={{ float: "left" }} className="info__h6 h--spacing-sm">
                  Subscription:
                </h6>
              </div>
            </div>
            <div className="row row--push-btm-xs">
              <div className="col-12">
                <h6 style={{ float: "left" }}>
                  {this.getDescription()}
                </h6>
              </div>
            </div>
            <div className="row row--push-btm-xs">
              <div className="col-12">
                <hr style={{ borderBottom: "1px solid #e1e6eae8", borderColor: "#9da7af4a" }} />
              </div>
            </div>
            <div className="row row--push-btm-xs">
              <div className="col-5">
                <div ref="back" tabIndex="6" className="btn btn--round btn--block btn--dark info__btn pull-left " style={{ padding: "0.7em" }} onClick={() => this.props.history.goBack()}><span className="ion-chevron-left arrowBack"> </span> Back</div>
              </div>
              <div className="col-7">
                <div tabIndex="7" className="btn btn--round btn--dark pull-right info__btn" style={{ width: "100%", padding: "0.7em" }} onClick={() => this.logout()}> Logout</div>
              </div>
            </div>
          </div>
          <div className="info__wrapper__footer">
            <div className="row">
              <div className="col-4" style={{ margin: "0 auto 1em", textAlign: "left" }}>
                <h5>{this.getDeviceId()}</h5>
                <QRCode
                  value={this.getDeviceId()}
                  size="125"
                  renderAs="svg"
                  className="qrCode2"
                />
                {/* <h6></h6> */}
              </div>
              <div className="col-4 info__wrapper__footer__version">
                <h6>{`v ${VERSION}`}</h6>
              </div>
              <div className="col-4 info__wrapper__footer__name " style={{ textAlign: "right" }}>
                <div style={{ marginBottom: "1.1em", marginRight: "1em" }}>
                  <h6 className="h--no-spacing">Elan vital</h6>
                  <small>Boris Marinin</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setHistory: (history) => dispatch(storeHistory(history)),
  fetchPlaylist: () => fetchPlaylist(dispatch)
});

export default connect((state) => {
  return {
  }
}, mapDispatchToProps)(InfoPage)
